/**
 * Устанавливаем заголовок странице
 * @param text - текстовая часть
 */import { COMPANY_NAME } from '../constants/settings';
export const setTitle = text => document.title = `${text} | ${COMPANY_NAME}`;